import { ConfigApi } from "@backstage/core-plugin-api";
import {
  createFrontendFeatureLoader,
  createFrontendPlugin,
  PageBlueprint,
} from "@backstage/frontend-plugin-api";
import { scorecardsEnabled } from "./config";
import { NAV } from "./nav";

export const loadScorecardsPage = () =>
  import("./scorecards/portfolio").then((m) => <m.ScorecardsPortfolioPage />);

const scorecardsPage = PageBlueprint.make({
  name: "scorecards",
  params: {
    path: NAV.scorecards.path,
    title: NAV.scorecards.title,
    icon: <NAV.scorecards.icon />,
    // The page renders its own header and tabs.
    noHeader: true,
    loader: loadScorecardsPage,
  },
});

/**
 * The Front Door plugin with only the surfaces switched on in config; empty
 * when every surface is off, so nothing is registered.
 */
export function createFrontDoorFeatures(
  config: Pick<ConfigApi, "getOptionalBoolean">
) {
  if (!scorecardsEnabled(config)) return [];
  return [
    createFrontendPlugin({
      pluginId: "front-door",
      title: "Front Door",
      extensions: [scorecardsPage],
    }),
  ];
}

/** Install this in `createApp({ features })`; it reads the surface switches at startup. */
export const frontDoorFeatures = createFrontendFeatureLoader({
  loader: ({ config }) => createFrontDoorFeatures(config),
});
